import { useEffect, useState } from "react";

import axiosInstance from "@/libs/axios";
import { PolicyDocuments } from "@/types/policy-document-types";

type UseFetchPolicyDocDataProps = {
  policyId?: string | null;
};

const useFetchPolicyDocData = ({
  policyId,
}: Readonly<UseFetchPolicyDocDataProps>) => {
  const [policyDocs, setPolicyDocs] = useState<PolicyDocuments[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (policyId) {
      setIsLoading(false);
      return;
    }
    const fetchPolicyDocData = async () => {
      try {
        const response = await axiosInstance.get(`/policy/documentLinks`);
        setPolicyDocs(
          response.data.data.attributes.securityQuestionResponse.documentLinks
        );
        setIsLoading(false);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error fetching policy document data:", error);
        setIsLoading(false);
        window.parent.location.href = "/";
      }
    };
    fetchPolicyDocData();
  }, [policyId]);

  return { policyDocs, isLoading };
};

export default useFetchPolicyDocData;
